import L from 'leaflet';
import turf from '@turf/turf';

import { featureGetZoom } from '../geojson-utilities';

/**
 * Given a leaflet map and a Feature Point with coordinates and zoom, gets the bbox.
 *
 * @param {object} arg - The arguments object.
 * @param {object} arg.map - The leaflet map.
 * @param {object} arg.mapLocation - The Feature Point.
 * @returns {number[]} The bounding box.
 */
const getBBoxFromCoordsAndZoom = ({ map, mapLocation }) => {
  const [centerLng, centerLat] = turf.getCoord(mapLocation);
  const overlayCenter = L.latLng(centerLat, centerLng);
  const mapZoom = featureGetZoom(mapLocation);
  const pixOffsetX = window.innerWidth / 2;
  const pixOffsetY = window.innerHeight / 2;
  const centerPoint = map.project(overlayCenter, mapZoom);
  const latLng1 = map.unproject(
    L.point([centerPoint.x - pixOffsetX, centerPoint.y + pixOffsetY]),
    mapZoom
  );
  const latLng2 = map.unproject(
    L.point([centerPoint.x + pixOffsetX, centerPoint.y - pixOffsetY]),
    mapZoom
  );
  const bounds = L.latLngBounds(latLng1, latLng2);
  return [bounds.getWest(), bounds.getSouth(), bounds.getEast(), bounds.getNorth()];
};

export default getBBoxFromCoordsAndZoom;
